import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthUsersGuard} from '../../../resources/guards/authUsers.guard';
import {DeletedUserIndexComponent} from '../deleted-user-index/deleted-user-index.component';
export const DeletedUserRoutes: Routes = [
  {
    path: 'deleted-users',
    data: {
      title: 'Deleted users',
      breadcrumbs: 'Deleted users',
      permission: 'DeletedUserIndexComponent'
    },
    component: DeletedUserIndexComponent,
    canActivate: [AuthUsersGuard],
    // canDeactivate: [FormChangesGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(DeletedUserRoutes)],
  exports: [RouterModule]
})
export class DeletedUserRoutesModule { }
